/** Look-up › Quality › Barcode Search (a packaging utility, user 2026-10-28). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { BarcodeSearchPage } from "@/features/packaging/components/utilities-page";

export const Route = createFileRoute("/_app/quality/barcode-search/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.barcode_search"))
      throw redirect({ to: "/" });
  },
  component: BarcodeSearchPage,
});
